import * as React from 'react'

import useContractFieldSetOptions from '../../options/useContractFieldSetOptions'
import NumberAndSelectInnerField from '../../inputs/NumberAndSelectInnerField'

const Clothes = ({ data, setData }) => {
  const { contractLaundryOptions } = useContractFieldSetOptions()
  React.useEffect(() => {
    if (
      data.isAdditionForLaundryEnabled === false &&
      ('additionForLaundry' in data || 'additionForLaundryType' in data)
    ) {
      const { additionForLaundry, additionForLaundryType, ...rest } = data
      setData(rest)
    }
  }, [data])
  return (
    <div className="tw-flex tw-flex-col tw-px-5 tw-items-end tw-justify-between tw-gap-2 tw-pt-3">
      <NumberAndSelectInnerField
        inputProps={{
          field: 'additionForLaundry',
          innerLabel: 'PLN',
          placeholder: '0,00',
          value: data.additionForLaundry?.toString(),
          onChange: (e) =>
            setData({
              ...data,
              additionForLaundry: e.target.value,
            }),
        }}
        fieldOptions={{
          fullWidth: true,
          inputSize: 'small',
        }}
        selectProps={{
          field: 'additionForLaundryType',
          required: true,
          placeholder: 'Wybierz ...',
          value: data.additionForLaundryType?.toString(),
          onChange: (e) =>
            setData({
              ...data,
              additionForLaundryType: Number(e.target.value),
            }),
          options: contractLaundryOptions,
        }}
      />
      {/* <RateReduce data={data} setData={setData} reduceType={'additional'} /> */}
    </div>
  )
}

export default Clothes
